(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('tr')) return;

  const selectors = [
    '.price', '.product__info-container', '.card-information', '.totals',
    '.cart-item', '.cart-drawer', '.auras-story', '.auras-package-showcase',
    '[data-cart-subtotal]', '.quick-order-list'
  ].join(',');

  const normalize = (raw) => {
    let text = raw;
    // 1,399.00 TRY / 1,399.00TL / 1,399.00 TL -> 1.399 TL
    text = text.replace(/(\d{1,3}(?:,\d{3})+)(?:\.(\d{2}))?\s*(?:TRY|TL|₺)/g, (_, whole, decimals) => {
      const trWhole = whole.replace(/,/g, '.');
      const decimalPart = decimals && decimals !== '00' ? `,${decimals}` : '';
      return `${trWhole}${decimalPart} TL`;
    });
    // 1399.00 TRY / 1399.00TL -> 1.399 TL
    text = text.replace(/\b(\d{4,})(?:\.(\d{2}))?\s*(?:TRY|TL|₺)/g, (_, whole, decimals) => {
      const grouped = Number(whole).toLocaleString('tr-TR');
      const decimalPart = decimals && decimals !== '00' ? `,${decimals}` : '';
      return `${grouped}${decimalPart} TL`;
    });
    // already Turkish numeric form but bad spacing/symbol
    text = text.replace(/(\d[\d.]*)(?:,(\d{2}))?\s*(?:TRY|₺|TL)\b/g, (_, whole, decimals) => {
      const decimalPart = decimals && decimals !== '00' ? `,${decimals}` : '';
      return `${whole}${decimalPart} TL`;
    });
    return text;
  };

  const walk = (root) => {
    if (!(root instanceof Element) || (!root.matches(selectors) && !root.querySelector(selectors))) return;
    const scope = root.matches(selectors) ? root : root.querySelector(selectors)?.parentElement || root;
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (!node.parentElement || node.parentElement.closest('script,style,select,option')) return;
      const next = normalize(node.nodeValue || '');
      if (next !== node.nodeValue) node.nodeValue = next;
    });
  };

  const run = () => document.querySelectorAll(selectors).forEach(walk);
  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; run(); });
  };

  document.addEventListener('DOMContentLoaded', run, { once: true });
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
